import React from 'react';
import { MinusCircleIcon } from '@phosphor-icons/react';
import { formatFileSize } from '@/utils/storage';
import { formatVideoTime } from '@/utils/time';
import { VideoThumbnail } from '@/components';
import { UploadFile } from '@/types/source-modal';

interface UploadFileItemProps {
    uploadFile: UploadFile;
    isActive: boolean;
    onSelect: () => void;
    onDelete: () => void;
}

export function UploadFileItem({
    uploadFile,
    isActive,
    onSelect,
    onDelete,
}: UploadFileItemProps) {
    return (
        <div
            className={`
                group flex items-center gap-3 p-3 rounded-[8px] cursor-pointer transition-all
                ${isActive ? 'bg-grey-500' : 'bg-transparent'}
            `}
            onClick={onSelect}
        >
            <div className="flex-shrink-0 w-20 aspect-video rounded overflow-hidden bg-grey-700">
                <VideoThumbnail
                    src={uploadFile.previewUrl}
                    className="w-full h-full object-cover pointer-events-none"
                />
            </div>

            <div className="flex-1 min-w-0">
                <p className="text-xs font-normal text-grey-200 truncate">
                    {uploadFile.fileName}
                </p>
                <div className="flex items-center gap-1.5 text-xs font-normal text-grey-200 mt-1">
                    <span>{formatFileSize(uploadFile.fileSize)}</span>
                    {uploadFile.duration && (
                        <>
                            <span>·</span>
                            <span>{formatVideoTime(uploadFile.duration)}</span>
                        </>
                    )}
                </div>
            </div>
            <button
                onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                }}
                className={`flex-shrink-0 text-grey-200 transition-opacity ${
                    isActive
                        ? 'opacity-100'
                        : 'opacity-0 group-hover:opacity-100'
                }`}
                aria-label="Remove file"
            >
                <MinusCircleIcon className="w-5 h-5" />
            </button>
        </div>
    );
}
